//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.Popper = require('@popperjs/core');

import 'jquery-ui/ui/widgets/draggable';

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// Or import only needed plugins
import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');
//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable = Draggable;
//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;

//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

//=====================================
//FANCY BOX
//=====================================
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// window.Fancybox = Fancybox;


//////////////////////////////////
// Google翻訳
//////////////////////////////////
function changeLanguage(lang) {
  document.documentElement.setAttribute("lang", lang);
  document.querySelectorAll("[data-en]").forEach(el => {
    if (lang === "en") {
      el.dataset.original = el.textContent;
      el.textContent = el.dataset.en;
    } else {
      if (el.dataset.original) {
        el.textContent = el.dataset.original;
      }
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  const langAttr = document.documentElement.lang;
  const urlParams = new URLSearchParams(window.location.search);
  const isTranslated = urlParams.get('_x_tr_tl') === 'en';
  if (langAttr === "en" || isTranslated) {
    changeLanguage("en");
  }
});


$(function(){
//////////////////////////////////
// Google翻訳
//////////////////////////////////
const isTranslated = location.hostname.includes('translate.goog');
if (isTranslated) {
  // 「JPN」リンクの data-url-jp を href にセット
  const $jaLink = $('#lang-ja');
  const originalUrl = $jaLink.data('url-ja');
  if (originalUrl) {
    $jaLink.attr('href', originalUrl);
  }
  let lastMarginTop = null;
  // bodyのmargin-topを監視して.menu_dropdownの位置調整
  setInterval(function () {
    const bodyMarginTop = parseInt($('body').css('margin-top')) || 0;

    if (bodyMarginTop !== lastMarginTop) {
      $('.menu_dropdown').css('transform', 'translateY(' + bodyMarginTop + 'px)');
      lastMarginTop = bodyMarginTop;
    }
  }, 300);
}

//////////////////////////////////
// 汎用SHOWボタン
//////////////////////////////////
$(".js-btn-show-next-hidden").on("click", function(){
  var $btn = $(this);
  var $nextHidden = $btn.closest(".wrap-btn-show-next-hidden").nextAll(".hidden").first(); // 次の .hidden を探す

  if ($nextHidden.length) {
      $nextHidden.slideDown(300); // アニメーションで表示
      $btn.addClass("is_done"); // ボタンをフェードアウト
  }
});


//////////////////////////////////
// HEADER MENU IMG SWITCH
//////////////////////////////////
$("#menu-main .wrap-in").each(function() {
  const $wrap = $(this);
  const $mainImage = $wrap.find(".switch-img img");
  const defaultImg = $mainImage.attr("src");

  $wrap.find(".c2 a").on("mouseenter", function() {
    const newImgSrc = $(this).data("img");
    if (newImgSrc && $mainImage.attr("src") !== newImgSrc) {
      $mainImage.stop(true, true).fadeOut(100, function() {
        $(this).attr("src", newImgSrc).fadeIn(100);
      });
    }
  });

  $wrap.find(".c2 a").on("mouseleave", function() {
    $mainImage.stop(true, true).fadeOut(100, function() {
      $(this).attr("src", defaultImg).fadeIn(100);
    });
  });
});

  //////////////////////////////////
// 画面幅が992px以上のときのみ `.draggable()` を実行
//////////////////////////////////

  if ($(window).width() >= 992) {
    $('.draggable').draggable();
  }

//////////////////////////////////

//////////////////////////////////
  const $window = $(window);
  const $header = $("#header");
  const headerHeight = $header.length ? $header.outerHeight() : 0;
    const offsetMargin = 120;
    let sections = [];

  ///////////////////////////////
  // アンカースクロール
  ///////////////////////////////
  function scrollToAnchor(anchorId) {
    const targetElement = document.querySelector(anchorId);
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }
  }
  if (window.location.hash) {
    scrollToAnchor(window.location.hash);
  }
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      scrollToAnchor(this.getAttribute("href"));
    });
  });

  ///////////////////////////////
  // SP BURGER MENU
  ///////////////////////////////
  function updateScrollState() {
    if ($window.scrollTop() >= headerHeight) {
      $("body").addClass("is_scroll");
    } else {
      $("body").removeClass("is_scroll");
    }
  }

  // ページ読み込み時に disable-scroll クラスが body にある場合はスクロールイベントを無効化
  setTimeout(function() {
    if (!$("body").hasClass("disable-scroll")) {
      $window.on("scroll load", updateScrollState);
    }
  }, 100);  // 100ミリ秒待ってから実行

  ///////////////////////////////
  // NAVI STICKY
  ///////////////////////////////

  // $(".sticky-nav").each(function() {
  //     var $nav = $(this);
  //     var targetSectionID = $nav.data("target");
  //     var $section = $("#" + targetSectionID);
  //     if ($section.length === 0) return; // 対象セクションがない場合はスキップ
  //     var $window = $(window);
  //     var $header = $("#header"); // ヘッダーの高さを考慮する場合
  //     var headerHeight = $header.length ? $header.outerHeight() : 0;
  //     var offsetMargin = 120; // 追加のオフセット

  //     $window.on("scroll", function() {
  //         var scrollTop = $window.scrollTop();
  //         var sectionTop = $section.offset().top - headerHeight - offsetMargin;
  //         var sectionBottom = sectionTop + $section.outerHeight();

  //         if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
  //             $nav.addClass("fixed");
  //         } else {
  //             $nav.removeClass("fixed");
  //         }
  //     });
  // });







  const $menuLinks = $(".sticky-nav li a");
  $menuLinks.each(function () {
    const targetID = $(this).attr("href").split("#")[1];
    const $section = $("#" + targetID).closest("article");
    if ($section.length) {
      sections.push({ id: targetID, $section: $section, $menuItem: $(this).parent("li") });
    }
  });
  function highlightSection() {
    const scrollTop = $window.scrollTop();
    sections.forEach(item => {
      const sectionTop = item.$section.offset().top - headerHeight - offsetMargin;
      const sectionBottom = sectionTop + item.$section.outerHeight();
      item.$menuItem.toggleClass("highlight", scrollTop >= sectionTop && scrollTop < sectionBottom);
    });
  }
  $window.on("scroll", highlightSection);



///////////////////////////////
// SLIDE-DOWN
///////////////////////////////
$(".item-slidedown dt").on("click", function(e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  var parent = $(this).closest(".item-slidedown");
  var answer = parent.find("dd");
  var isOpen = parent.attr("aria-expanded") === "true";

  if (isOpen) {
    parent.attr("aria-expanded", "false");
    answer.slideUp(300);
  } else {
    parent.attr("aria-expanded", "true");
    answer.slideDown(300);
  }
});

// dd 内をクリックしても親要素のイベントを発火させない
$(".item-slidedown dd").on("click", function(e) {
  e.stopPropagation();
});

///////////////////////////////
// SWITCH BUTTON OPEN ALL
///////////////////////////////
$(".toggle").on("click", function() {
  $(this).toggleClass("checked");
  var isChecked = !$(this).find('input[name="check"]').prop("checked");
  $(this).find("input").prop("checked", isChecked);

  // data-target の取得
  var targetSection = $(this).attr("data-target");

  // 該当の section 内の dt 要素を操作
  $("#" + targetSection).find("dt").each(function() {

      if (isChecked) {
          $(this).parent('dl').attr("aria-expanded", "true");
          $(this).next("dd").slideDown(300);
      } else {
          $(this).parent('dl').attr("aria-expanded", "false");
          $(this).next("dd").slideUp(300);
      }
  });
});



/////////////////////////////////////////////
/// MAQUEEE
//////////////////////////////////////////

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
class Marquee {
  constructor() {
    this.els = document.querySelectorAll('.marquee');
    if (!this.els) return;
    this.init();
  }

  init() {
    this.els.forEach(el => {
      if (getComputedStyle(el).display === 'none') return;

      const options = {
        speed: el.dataset.marqueeSpeed || 60,
        direction: el.dataset.marqueeDirection || 'left',
        pauseOnHover: el.dataset.marqueeHover === 'true'
      };
      this.Marquee(el, options);
    });
  }

  Marquee(el, options) {
    const { speed, direction, pauseOnHover } = options;
    const wrapper = el.querySelector('.marquee-wrapper');
    const content = el.querySelector('.marquee-content');

    this.appendContent(content, wrapper);
    this.updateWrapperWidth(content, wrapper);
    const animation = this.Animation(wrapper, speed, direction);
    this.touchEvent(el, animation, wrapper);
    this.hoverEvent(el, animation, pauseOnHover);
    this.observerEvent(el, animation);
  }

  updateWrapperWidth(content, wrap) {
    const contentWidth = content.getBoundingClientRect().width;
    if (contentWidth === 0) return;
    const gap = parseInt(getComputedStyle(content).columnGap);
    wrap.style.width = `${contentWidth + gap}px`;
  }

  appendClone(content, wrap) {
    const clone = content.cloneNode(true);
    wrap.appendChild(clone);
  }

  appendContent(content, wrap) {
    const innerWidth = window.innerWidth;
    const contentWidth = content.getBoundingClientRect().width;

    this.appendClone(content, wrap);

    if (contentWidth < innerWidth) {
      const numClones = Math.ceil(innerWidth / contentWidth);
      for (let i = 0; i < numClones; i++) {
        this.appendClone(content, wrap);
      }
    }
  }

  Animation(wrap, speed, direction) {
    const wrapWidth = wrap.getBoundingClientRect().width;
    if (wrapWidth === 0) return;

    const keyframes = direction === 'left'
      ? [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }]
      : [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }];

    const options = {
      duration: (wrapWidth / speed) * 1000,
      iterations: Infinity
    };

    return wrap.animate(keyframes, options);
  }

  hoverEvent(el, animation, hasOpt) {
    if (!hasOpt) return;
    el.addEventListener('mouseenter', () => animation.pause());
    el.addEventListener('mouseleave', () => animation.play());
  }

  observerEvent(el, animation) {
    const observerOptions = { root: null, threshold: 0 };

    const observer = new IntersectionObserver(entries => {
      entries[0].isIntersecting ? animation.play() : animation.pause();
    }, observerOptions);

    observer.observe(el);
  }

  touchEvent(el, animation, wrapper) {
    let isDown = false;
    let startX;
    let animationProgress;

    if ('ontouchstart' in window) {
      wrapper.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX;
        animationProgress = animation.currentTime;
        animation.pause();
      });

      wrapper.addEventListener('touchend', () => {
        isDown = false;
        animation.play();
      });

      wrapper.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        const moveX = e.touches[0].pageX - startX;
        animation.currentTime = animationProgress - moveX * 100; // 10倍に増幅
      });
    }
  }
}

const marquee = new Marquee();





















/////////////////////////////////////////////
//DEV
/////////////////////////////////////////////

$(document).ready(function () {

});


/////////////////////////////////////////////
// HEADER DROPDOWN MENU
/////////////////////////////////////////////
  // メニューアイテムを選択
  $('li[aria-expanded]').each(function() {
    var $dropdown = $(this); // 現在のリストアイテム
    var $trigger = $dropdown.find('a'); // 直下のリンク (hover対象)
    var $menu = $dropdown.find('.menu_dropdown'); // ドロップダウンメニュー

    // hover で開く
    $trigger.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // ドロップダウンメニューにもmouseenterを設定
    $menu.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // マウスが外れたら閉じる
    $dropdown.on('mouseleave', function() {
      // li から外れたときにメニューが閉じる
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });

    // ドロップダウンメニューから外れたときも閉じる
    $menu.on('mouseleave', function() {
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });
  });


/////////////////////////////////////////////
//TOOLTIP
/////////////////////////////////////////////
  // $('[data-toggle="tooltip"]').tooltip()


/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
// window.App.loadSection = function(url, modalId,modalTitle) {
//   $.ajax({
//     type: 'GET',
//     url: url,
//     success: function(data) {
//       $(modalId).find(".ajx_content_output").html(data);
//       $(modalId).find('.modal-title').html(modalTitle);
//       $(modalId).modal('show');
//     }
//   });
// };

window.App = window.App || {}; // Appが未定義の場合は空オブジェクトを作成
window.App.loadSection = function(modalId) {
  console.log("Modal ID:", modalId); // ここでIDを確認
  if (!modalId.startsWith("#")) return; // "#" がない場合は処理しない

  $(modalId).modal('show');
};



///////////////////////////////
// MODAL with numbered nav
///////////////////////////////
window.App = window.App || {};
App.currentContentIndex = 1; // Keep track of the currently displayed index

App.showModalContent = function(modalId, className, title, contentId) {
  const $modal = $('#' + modalId);
  if ($modal.length === 0) {
    console.warn(`Modal with ID "${modalId}" not found.`);
    return;
  }

  // ★ クラスの追加処理（必要に応じて一度削除してから追加）
  if (className) {
    $modal.removeClass(function(index, className) {
      return (className.match(/(^|\s)customClass_\S+/g) || []).join(' ');
    });
    $modal.addClass('customClass_' + className); // プレフィックス付与して他と区別
  }

  // タイトル更新
  $modal.find('.modal-title').text(title);

  // コンテンツの切り替え
  if (contentId) {
    $modal.find('.modal_content_item').addClass('d-none');
    const $target = $modal.find(contentId);
    if ($target.length > 0) {
      $target.removeClass('d-none');
      const match = contentId.match(/(\d+)$/);
      if (match) {
        App.currentContentIndex = parseInt(match[1]);
        // App.highlightActiveButton($modal);
      }
    } else {
      console.warn(`Content section "${contentId}" not found inside modal "${modalId}".`);
    }
  }

  // モーダル表示
  const modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
  modalInstance.show();
};


// Switch content based on the button clicked
App.switchTo = function(contentId, title = null) {
  const $button = $(event.target);
  const $modalDialog = $button.closest('.modal-dialog');
  const $modal = $modalDialog.closest('.modal');

  // 現在のモーダル内のコンテンツを非表示
  $modal.find('.modal_content_item').addClass('d-none');

  // 対象コンテンツを表示
  const $target = $modal.find(`#${contentId}`);
  if ($target.length > 0) {
    $target.removeClass('d-none');
  }

  // タイトルを変更（任意）
  if (title) {
    $modal.find('.modal-title').text(title);
  }

  // すでに付いている customClass_X をすべて削除
  $modal.removeClass(function(index, className) {
    return (className.match(/customClass_\d+/g) || []).join(' ');
  });

  // data-index を読み取って customClass_X を付ける
  const index = $button.data('index');
  if (index) {
    $modal.addClass('customClass_' + index);
  }
};


/////////////////////////////////////////////
//SP BUGER MENU
/////////////////////////////////////////////
$('#global_burgermenu > button').on('click', function() {
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $('body').addClass('is-sp-menu');
      $('body').removeClass('rm-sp-menu');
  }else{
      $('body').removeClass('is-sp-menu');
      $('body').addClass('rm-sp-menu');
  }
  return false;
});

$("#global-sp-menu").on("click",function(){
  $('#global_burgermenu > button').trigger('click');
})

$(document).on('click', function(event) {
  if ($('body').hasClass('is-sp-menu') && !$(event.target).closest("#global-sp-menu").length) {
    $('#global_burgermenu > button').trigger('click');
  }
});



//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    spaceBetween: 5,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

/* ==================
FANCYBOX
===================== */
// Fancybox.bind("[data-fancybox]", {
//   // Fancybox を body の最後に追加
//   placeFocusBack: false,
//   parentEl: "body",
//   on: {
//     init: () => {
//       document.querySelectorAll('.modal-backdrop').forEach(el => el.style.zIndex = "1040");
//     },
//     destroy: () => {
//       document.querySelectorAll('.modal-backdrop').forEach(el => el.style.zIndex = "");
//     }
//   }
// });


  // すべての `data-fancybox` 属性を持つ要素を取得
  const fancyboxGroups = new Set(
    [...document.querySelectorAll("[data-fancybox]")].map(el => el.getAttribute("data-fancybox"))
  );

  // 取得した各 `data-fancybox` の値に対して Fancybox をバインド
  fancyboxGroups.forEach(group => {
    Fancybox.bind(`[data-fancybox='${group}']`, {
      Thumbs: {
        autoStart: true,
        hideOnClose: true,
        type: "classic",
      },
      Carousel: {
        Navigation: false,
        transition: "slide",
        infinite: true,
      },
      Toolbar: {
        display: {
          left: [],
          middle: ["prev", "infobar", "next"],
          right: ["close"],
        },
      },
      Image: {
        fit: "contain",
      },
      Slideshow: {
        autoStart: false,
        speed: 3000,
      },
      Keyboard: {
        Escape: true,
        Delete: false,
      },
      // touch: true, // タッチジェスチャーを有効化
      // zoom: true, // ダブルタップでズーム
      // dragToClose: false, // スワイプで閉じる動作を無効化

      Hash: false,
      caption: function (fancybox, slide) {
        let title = slide.triggerEl.dataset.title || '';
        let content = slide.triggerEl.dataset.content || '';

        return `
          ${title ? `<h3 class="fancy_title">${title}</h3>` : ''}
          ${content ? `<span class="fancy_content">${content}</span>` : ''}
        `;
      }
    });
  });

// Fancybox.bind("[data-fancybox='gallery']", {
//   Thumbs: {
//     autoStart: true, // サムネイルパネルをデフォルトで開く
//     hideOnClose: true, // モーダルを閉じるとサムネイルも非表示にする
//     type: "classic",
//   },
//   Carousel: {
//     Navigation: false,
//   },
//   Toolbar: {
//     display: {
//       left: [],
//       middle: ["prev", "infobar", "next"],
//       right: ["close"],
//     },
//   },
//   Image: {
//     fit: "contain", // 画像の表示方法（cover, contain, inside, outside）
//   },

//   Carousel: {
//     transition: "slide", // スライドアニメーション ("fade", "slide")
//     infinite: true, // ループ（最後のスライドの後に最初に戻る）
//   },
//   Slideshow: {
//     autoStart: false, // 自動スライド開始
//     speed: 3000, // スライド間の時間（ミリ秒）
//   },
//   Keyboard: {
//     Escape: true,  // ESC キーで閉じる
//     Delete: false, // Delete キーで閉じる（不要なら false）
//   },
//   Hash: false, // URL に #hash を追加する機能
//   caption: function (fancybox, slide) {
//     let title = slide.triggerEl.dataset.title || '';
//     let alt = slide.triggerEl.dataset.alt || '';
//     let caption = slide.triggerEl.dataset.caption || '';
//     let content = slide.triggerEl.dataset.content || '';

//     let formattedCaption = `
//       ${title ? `<h3 class="fancy_title">${title}</h3>` : ''}
//       ${content ? `<span class="fancy_content">${content}</span>` : ''}
//     `;
//     return formattedCaption;
//   }
// });


//////////////////////////////
//カウントアップ
//////////////////////////////
$(".txt-num > i").each(function(index, element) {
  var $target = $(element);
  var targetText = $target.text();
  var targetNumber = parseInt(targetText, 10);
  var paddingLength = targetText.length; // 元の文字列の桁数を保持

  var duration = 500; // アニメーションの継続時間（ミリ秒）
  var currentNumber = 0; // 現在の数字

  function animateNumber() {
    $({ countNum: currentNumber }).animate({ countNum: targetNumber }, {
      duration: duration,
      easing: 'linear',
      step: function() {
        var value = Math.floor(this.countNum).toString().padStart(paddingLength, '0');
        $target.text(value);
        $target.addClass('animating').removeClass("animating_done"); 
      },
      complete: function() {
        var finalValue = targetNumber.toString().padStart(paddingLength, '0');
        $target.text(finalValue);
        $target.removeClass('animating').addClass("animating_done");
      }
    });
  }
  // カウントアップのアニメーションをスクロールトリガーとして設定
  gsap.to({}, {
    duration: 0.01,
    scrollTrigger: {
      trigger: $target.parent(), // 親要素をトリガーにする
      start: "top 80%", // スクロール位置でトリガー
      onEnter: animateNumber, // 要素がビューポートに入ったときにアニメーションを開始
      // markers: true // マーカーを表示（デバッグ用）
    }
  });
});



//////////////////////////////////
// gsap.registerPlugin(ScrollTrigger);
//////////////////////////////////
  gsap.registerPlugin(ScrollTrigger);
  const dls = document.querySelectorAll(".lst-history dl");
  dls.forEach((dl) => {
    gsap.fromTo(dl,
      { scale: 0.1, opacity: 0 }, // 初期状態（小さく、透明）
      { 
        scale: 1, opacity: 1, duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: dl,
          start: "top 95%",  // 要素の上端が画面の75%位置に来たら開始
          end: "top 80%",    // 画面の40%位置までアニメーション
          scrub: true,       // スクロールと連動
          toggleActions: "play reverse play reverse" // スクロールを戻すと元に戻る
        }
      }
    );
  });

///////////////////////////////
// GSAPアニメーション（修正後）
///////////////////////////////
// .parallax-bg が存在する場合のみ GSAP 実行
if (document.querySelector(".parallax-bg")) {
  gsap.to(".parallax-bg", {
    y: 300,
    scrollTrigger: {
      trigger: ".parallax-bg",
      start: "top bottom",
      end: "bottom top",
      scrub: 0.5
    }
  });
}



// ////////////////////////////////////
// /// DEV
// ////////////////////////////////////
// $(".dev-bg i").on("click", function(e) {
//   e.preventDefault();
//   var classNum = $(this).data("bg");
//   if(classNum === "none"){
//       $(this).parent(".dev-bg").remove();
//   }
//   $(this).closest("SECTION, .swiper-slide").removeClass(function(index, className) {
//       return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
//   }).addClass("mv-" + classNum);
//   });
//   $('[data-js="add_hover"]').hover(function() {
//   $(this).closest('SECTION').addClass('is_hover');
//   }, function() {
//   $(this).closest('SECTION').removeClass('is_hover');
//   });
  

// /////////////////////////////////////////////
// //DEV TARGET KILL
// /////////////////////////////////////////////
// $(".kill").on("click", function() {
//   if (confirm("本当に削除しますか？")) {
//       $(this).closest(".targetkill").hide();
//   }
// });

// $("#dev-print-r").on("dblclick", function() {
//   $(this).fadeOut(500); // 500ms（0.5秒）かけてフェードアウト
// });
// /////////////////////////////////////////////
// //SITEMAP
// /////////////////////////////////////////////
// window.App.loadSection = function(modalId) {
//   $.ajax({
//     success: function(data) {
//       $(modalId).modal('show');
//     }
//   });
// };


/////////////////////////////////////////////
    // ACF カラーピッカーのカスタムカラーを設定
/////////////////////////////////////////////
// acf.add_filter('color_picker_args', function( args, $field ){
//     // カスタムカラーの配列を設定
//     args.palettes = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#000000', '#ffffff'];
//     return args;
// });



});




// // #an-kaori が存在する場合のみ GSAP 実行
// if (document.querySelector("#an-kaori")) {
//   gsap.fromTo("#an-kaori",
//     { scale: 1, opacity: 0, x: "-500px" },
//     { 
//       scale: 1, opacity: 1, x: 0, duration: 1, ease: "power2.out",
//       onComplete: () => {
//         gsap.to("#an-kaori", {
//           scale: 1.1, y: 3, duration: 2.5, repeat: -1, yoyo: true, ease: "sine.inOut"
//         });
//       }
//     }
//   );
// }



//=====================================
// SweetAlert2
//=====================================
// import Swal from 'sweetalert2';
// window.Swal = Swal;
// Example usage of SweetAlert2
// document.addEventListener('DOMContentLoaded', () => {
//     const modalBtn = document.getElementById('modalBtn');
//     if (modalBtn) {
//         modalBtn.addEventListener('click', () => {
//             Swal.fire({
//                 title: 'モーダルタイトル',
//                 text: 'これは説明文です。',
//                 icon: 'info',
//                 confirmButtonText: '閉じる'
//             });
//         });
//     }
// });
//=====================================
//Muuri
//=====================================
// const Muuri = require('muuri').default;
// window.Muuri = Muuri;

